import { Box } from "@chakra-ui/react";

import { tableWrapperStyles } from "./style";
import { TTableWrapper } from "./types";

const TableWrapper = ({
  children,
  radius = "20px",
  className,
}: TTableWrapper) => {
  return (
    <Box
      bg="white"
      borderRadius={radius}
      py="6"
      className={`${className}`}
      css={tableWrapperStyles}
    >
      {children}
    </Box>
  );
};

export default TableWrapper;
